// Carousel: wheel-scroll + prev/next buttons + optional auto-advance
document.querySelectorAll("[data-carousel]").forEach((carousel) => {
  carousel.addEventListener("wheel", (event) => {
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      carousel.scrollLeft += event.deltaY;
      event.preventDefault();
    }
  }, { passive: false });
});

document.querySelectorAll("[data-carousel-wrap], .mareclo-carousel-wrap").forEach((wrap) => {
  const car = wrap.querySelector("[data-carousel]");
  if (!car) return;
  const step = () => Math.min(car.clientWidth * 0.85, 520);
  wrap.querySelector("[data-carousel-prev]")?.addEventListener("click", () => car.scrollBy({ left: -step(), behavior: "smooth" }));
  wrap.querySelector("[data-carousel-next]")?.addEventListener("click", () => car.scrollBy({ left: step(), behavior: "smooth" }));
});

// Auto-advance bestseller (desktop only)
document.querySelectorAll("[data-autoscroll]").forEach((car) => {
  if (window.matchMedia("(max-width: 900px)").matches) return;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let paused = false;
  car.addEventListener("mouseenter", () => (paused = true));
  car.addEventListener("mouseleave", () => (paused = false));
  setInterval(() => {
    if (paused || reduceMotion.matches || document.hidden || car.contains(document.activeElement) || !car.isConnected) return;
    if (car.scrollLeft + car.clientWidth >= car.scrollWidth - 4) car.scrollTo({ left: 0, behavior: "smooth" });
    else car.scrollBy({ left: 280, behavior: "smooth" });
  }, 3600);
});

// Shop the Look: hotspot ↔ row sync
document.querySelectorAll("[data-look]").forEach((look) => {
  const dots = look.querySelectorAll("[data-look-dot]");
  const rows = look.querySelectorAll("[data-look-row]");
  const activate = (i) => {
    dots.forEach((d) => d.classList.toggle("is-active", d.dataset.lookDot === String(i)));
    rows.forEach((r) => r.classList.toggle("is-active", r.dataset.lookRow === String(i)));
  };
  dots.forEach((d) => {
    d.addEventListener("click", () => activate(d.dataset.lookDot));
    d.addEventListener("mouseenter", () => activate(d.dataset.lookDot));
  });
  rows.forEach((r) => {
    r.addEventListener("click", () => activate(r.dataset.lookRow));
    r.addEventListener("mouseenter", () => activate(r.dataset.lookRow));
  });
});

// Shop the Look: buy the complete look (hotspot products)
document.querySelectorAll("[data-look-addall]").forEach((button) => {
  button.addEventListener("click", async () => {
    const look = button.closest("[data-look]");
    const list = look?.querySelector(".welanor-atlas__look-list");
    const status = look?.querySelector("[data-look-status]");
    const addUrl = list?.dataset.cartAdd || "/cart/add";
    const cartUrl = list?.dataset.cartUrl || "/cart";
    const items = Array.from(look?.querySelectorAll("[data-look-row][data-variant-id]") || [])
      .map((row) => ({ id: Number(row.dataset.variantId), quantity: 1 }))
      .filter((item) => item.id);
    const say = (key) => { if (status) status.textContent = (window.welanorLookText && window.welanorLookText[key]) || ""; };
    if (!items.length) { say("empty"); return; }
    button.disabled = true;
    say("adding");
    try {
      const response = await fetch(`${addUrl}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error("look add failed");
      document.dispatchEvent(new CustomEvent("welanor:cart:added", { detail: { fallback: cartUrl } }));
      say("added");
      button.disabled = false;
    } catch (error) {
      say("error");
      button.disabled = false;
    }
  });
});

// Tier selector + tabs (PDP)
document.querySelectorAll("[data-tier-selector]").forEach((group) => {
  group.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-tier]");
    if (!button) return;
    group.querySelectorAll("button").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
  });
});

document.querySelectorAll("[data-tabs]").forEach((tabs) => {
  const buttons = Array.from(tabs.querySelectorAll("button[data-tab]"));
  const activate = (button) => {
    const key = button.dataset.tab;
    buttons.forEach((item) => {
      const active = item === button;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", String(active));
      item.tabIndex = active ? 0 : -1;
    });
    tabs.querySelectorAll("[data-panel]").forEach((panel) => {
      const active = panel.dataset.panel === key;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });
  };
  tabs.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-tab]");
    if (button) activate(button);
  });
  buttons.forEach((button, index) => {
    button.addEventListener("keydown", (event) => {
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
      else next = (index - 1 + buttons.length) % buttons.length;
      buttons[next].focus();
      activate(buttons[next]);
    });
  });
});

// WELANOR mobile navigation: a full-height catalog index with focus return.
document.querySelectorAll("[data-mobile-menu-toggle]").forEach((toggle) => {
  const menu = document.getElementById(toggle.getAttribute("aria-controls"));
  const close = menu?.querySelector("[data-mobile-menu-close]");
  if (!menu || !close) return;
  const setOpen = (open) => {
    menu.hidden = !open;
    toggle.setAttribute("aria-expanded", String(open));
    document.documentElement.classList.toggle("welanor-menu-open", open);
    if (open) close.focus();
    else toggle.focus();
  };
  toggle.addEventListener("click", () => setOpen(true));
  close.addEventListener("click", () => setOpen(false));
  menu.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setOpen(false);
  });
});

// Shopify Markets localization: native controls keep language, country and currency explicit.
document.querySelectorAll("[data-localization-select]").forEach((select) => {
  select.addEventListener("change", () => {
    if (!select.form) return;
    if (typeof select.form.requestSubmit === "function") select.form.requestSubmit();
    else select.form.submit();
  });
});

// Welanor Beauty Atlas: keyboard chapters, mobile routine drawer and selected routine purchase.
document.querySelectorAll("[data-atlas]").forEach((atlas) => {
  const tabs = Array.from(atlas.querySelectorAll("[data-atlas-tab]"));
  const panels = Array.from(atlas.querySelectorAll("[data-atlas-panel]"));
  const drawer = atlas.querySelector("[data-atlas-drawer]");
  const portrait = atlas.querySelector("[data-atlas-image]");
  const texture = atlas.querySelector("[data-atlas-texture]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mobile = () => window.matchMedia("(max-width: 760px)").matches;

  // Cross-fade a leaf image instead of hard-swapping its source (page-turn feel).
  const swapImage = (container, source) => {
    const img = container?.querySelector("img:not(.welanor-atlas__ghost)");
    if (!img || !source) return;
    const current = new URL(img.currentSrc || img.src, window.location.href).href;
    const next = new URL(source, window.location.href).href;
    if (current === next) return;
    if (reducedMotion) {
      img.removeAttribute("srcset");
      img.src = source;
      return;
    }
    container.querySelectorAll(".welanor-atlas__ghost").forEach((ghost) => ghost.remove());
    const ghost = img.cloneNode();
    ghost.className = "welanor-atlas__ghost";
    ghost.removeAttribute("srcset");
    ghost.removeAttribute("sizes");
    ghost.src = current;
    ghost.style.opacity = "1";
    container.insertBefore(ghost, img);
    img.style.opacity = "0";
    const loader = new Image();
    const reveal = () => {
      img.removeAttribute("srcset");
      img.src = source;
      window.requestAnimationFrame(() => { img.style.opacity = "1"; });
      window.setTimeout(() => ghost.remove(), 3200);
    };
    loader.onload = reveal;
    loader.onerror = reveal;
    loader.src = source;
  };

  // Hover focus: show the hovered product full-leaf, return to the grid on leave.
  const focus = atlas.querySelector("[data-atlas-focus]");
  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  let focusTimer = 0;
  let focusItem = null;
  const hideFocus = (immediate = false) => {
    window.clearTimeout(focusTimer);
    focusItem = null;
    if (!focus) return;
    focus.classList.remove("is-visible");
    if (immediate) focus.classList.add("is-instant");
    window.setTimeout(() => focus.classList.remove("is-instant"), 50);
  };
  const showFocus = (item) => {
    if (!focus || !item || item === focusItem) return;
    const source = item.dataset.atlasZoom;
    if (!source) return;
    focusItem = item;
    const img = focus.querySelector("img");
    const vendor = item.querySelector(".welanor-atlas__product-info > span");
    const title = item.querySelector(".welanor-atlas__product-info > a");
    const price = item.querySelector(".mareclo-price");
    focus.querySelector("[data-atlas-focus-vendor]").textContent = vendor ? vendor.textContent : "";
    focus.querySelector("[data-atlas-focus-title]").textContent = title ? title.textContent : "";
    focus.querySelector("[data-atlas-focus-price]").innerHTML = price ? price.innerHTML : "";
    const addBtn = focus.querySelector("[data-atlas-focus-add]");
    if (addBtn) { addBtn.dataset.variantId = item.dataset.variantId || ""; addBtn.disabled = !item.dataset.variantId; }
    if (img.getAttribute("src") !== source) {
      img.classList.add("is-loading");
      img.onload = () => img.classList.remove("is-loading");
      img.src = source;
    }
    focus.classList.add("is-visible");
  };
  if (focus && canHover && drawer) {
    drawer.addEventListener("mouseover", (event) => {
      const trigger = event.target.closest(".welanor-atlas__product-image, .welanor-atlas__product-info > a, [data-atlas-focus]");
      if (!trigger) { if (focusItem && !event.target.closest("[data-atlas-focus]")) hideFocus(); return; }
      const item = trigger.closest("[data-atlas-product]") || focusItem;
      if (!item || !drawer.contains(item)) return;
      window.clearTimeout(focusTimer);
      focusTimer = window.setTimeout(() => showFocus(item), focusItem ? 40 : 160);
    });
    drawer.addEventListener("mouseout", (event) => {
      const item = event.target.closest("[data-atlas-product], [data-atlas-focus]");
      const next = event.relatedTarget instanceof Element ? event.relatedTarget.closest(".welanor-atlas__product-image, .welanor-atlas__product-info > a, [data-atlas-focus]") : null;
      if (!item || next) return;
      hideFocus();
    });
    drawer.addEventListener("mouseleave", () => hideFocus());
  }

  const activate = (id, focusPanel = false) => {
    const tab = tabs.find((item) => item.dataset.atlasTab === id);
    const panel = panels.find((item) => item.dataset.atlasPanel === id);
    if (!tab || !panel) return;
    tabs.forEach((item) => {
      const active = item === tab;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach((item) => {
      const active = item === panel;
      item.classList.toggle("is-active", active);
      item.hidden = !active;
    });
    const chapter = tab.closest("[data-atlas-tab]");
    swapImage(portrait, chapter?.dataset.atlasImage);
    swapImage(texture, chapter?.dataset.atlasTexture);
    hideFocus(true);
    if (!reducedMotion) {
      atlas.classList.remove("is-turning");
      void atlas.offsetWidth; // restart the page-turn timeline on rapid clicks
      atlas.classList.add("is-turning");
      window.clearTimeout(atlas.turnTimer);
      atlas.turnTimer = window.setTimeout(() => atlas.classList.remove("is-turning"), 5400);
    }
    if (mobile()) drawer?.classList.add("is-open");
    if (focusPanel) {
      if (!reducedMotion) drawer?.scrollIntoView({ behavior: "smooth", block: "start" });
      else drawer?.scrollIntoView();
      drawer?.focus({ preventScroll: true });
    }
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => activate(tab.dataset.atlasTab));
    tab.addEventListener("keydown", (event) => {
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
      else next = (index - 1 + tabs.length) % tabs.length;
      tabs[next].focus();
      activate(tabs[next].dataset.atlasTab);
    });
  });

  // "Weiter shoppen" prompt: 5s after the routine drawer opens, invite the
  // visitor to continue to the commerce sections below (index.yeni only).
  const continueBtn = atlas.querySelector("[data-atlas-continue]");
  // move out of the atlas: its transformed ancestors would trap position:fixed
  if (continueBtn) document.body.appendChild(continueBtn);
  let continueTimer;
  const armContinue = () => {
    if (!continueBtn || continueBtn.dataset.done) return;
    window.clearTimeout(continueTimer);
    continueTimer = window.setTimeout(() => {
      // Shopify's draft preview bar sits over the default position
      if (document.getElementById("PBarNextFrameWrapper") || document.getElementById("preview-bar-iframe")) continueBtn.classList.add("is-lifted");
      continueBtn.hidden = false;
      requestAnimationFrame(() => continueBtn.classList.add("is-visible"));
    }, 5000);
  };
  const dismissContinue = () => {
    window.clearTimeout(continueTimer);
    if (!continueBtn) return;
    continueBtn.classList.remove("is-visible");
    window.setTimeout(() => { continueBtn.hidden = true; }, 450);
  };
  // arm right away: the prompt appears 5s after the page (slider) is up,
  // and retires quietly once the visitor scrolls past the atlas on their own
  if (continueBtn) {
    armContinue();
    const retireOnScroll = () => {
      if (continueBtn.dataset.done) return;
      if (atlas.getBoundingClientRect().bottom < window.innerHeight * 0.5) {
        continueBtn.dataset.done = "1";
        dismissContinue();
        window.removeEventListener("scroll", retireOnScroll);
      }
    };
    window.addEventListener("scroll", retireOnScroll, { passive: true });
  }
  continueBtn?.addEventListener("click", () => {
    continueBtn.dataset.done = "1";
    dismissContinue();
    if (mobile()) drawer?.classList.remove("is-open");
    const target = document.querySelector(".welanor-atlas-section ~ .shopify-section");
    if (!target) return;
    // measure a frame later: closing states may shift the layout mid-scroll
    requestAnimationFrame(() => {
      const top = window.scrollY + target.getBoundingClientRect().top;
      window.scrollTo({ top, behavior: reducedMotion ? "auto" : "smooth" });
    });
  });

  atlas.querySelectorAll("[data-atlas-discover]").forEach((button) => {
    button.addEventListener("click", () => {
      const active = atlas.querySelector("[data-atlas-tab].is-active");
      if (active) activate(active.dataset.atlasTab, true);
      armContinue();
    });
  });
  atlas.querySelectorAll("[data-atlas-close]").forEach((button) => {
    button.addEventListener("click", () => {
      drawer?.classList.remove("is-open");
      dismissContinue();
      atlas.querySelector("[data-atlas-tab].is-active")?.focus();
    });
  });

  atlas.querySelectorAll("[data-atlas-routine]").forEach((form) => {
    form.addEventListener("submit", (event) => {
      if (event.submitter?.matches("[data-atlas-add-all]")) event.preventDefault();
    });
    form.querySelector("[data-atlas-add-all]")?.addEventListener("click", async () => {
      const button = form.querySelector("[data-atlas-add-all]");
      const status = form.querySelector("[data-atlas-status]");
      const items = Array.from(form.querySelectorAll("[data-atlas-product]"))
        .filter((item) => item.dataset.available === "true" && item.querySelector("[data-atlas-product-toggle]")?.checked)
        .map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 }))
        .filter((item) => item.id);
      if (!items.length) {
        if (status) status.textContent = window.welanorCommerceText.empty;
        return;
      }
      button.disabled = true;
      if (status) status.textContent = window.welanorCommerceText.adding;
      try {
        const response = await fetch(`${form.action}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error("cart add failed");
        document.dispatchEvent(new CustomEvent("welanor:cart:added", { detail: { fallback: form.dataset.cartUrl } }));
        button.disabled = false;
        if (status) status.textContent = "";
      } catch (error) {
        if (status) status.textContent = window.welanorCommerceText.error;
        button.disabled = false;
      }
    });
  });
});

// Cart drawer: AJAX add-to-cart from "+" buttons, slide-in panel, quantity changes, section re-render.
(() => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) {
    document.addEventListener("welanor:cart:added", (event) => { if (event.detail?.fallback) window.location.assign(event.detail.fallback); });
    return;
  }
  const panel = drawer.querySelector(".welanor-drawer__panel");
  const text = (key) => (window.welanorDrawerText && window.welanorDrawerText[key]) || "";
  let lastFocus = null;
  const setCount = (n) => {
    document.querySelectorAll(".mareclo-cart-count").forEach((el) => { el.textContent = n; el.hidden = !n; });
    const link = document.querySelector(".mareclo-cart-link");
    if (link && n && !link.querySelector(".mareclo-cart-count")) { const b = document.createElement("span"); b.className = "mareclo-cart-count"; b.textContent = n; link.appendChild(b); }
    drawer.querySelectorAll("[data-cart-drawer-count]").forEach((el) => { el.textContent = n; });
  };
  // section_id, not sections=. The drawer is a static section in theme.liquid; the JSON `?sections=`
  // form only answers for it on some templates (a collection, page or /cart returns that template's
  // own JSON with no cart-drawer key), so every re-render outside the homepage and search silently
  // did nothing. See the same note in sections/cart-drawer.liquid.
  const refresh = async () => {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`, { headers: { Accept: "text/html" } });
    if (!res.ok) throw new Error("section render failed");
    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const fresh = doc.querySelector("[data-cart-drawer]");
    if (!fresh) throw new Error("cart drawer missing from section render");
    drawer.querySelector("[data-cart-drawer-body]").innerHTML = fresh.querySelector("[data-cart-drawer-body]").innerHTML;
    drawer.querySelector(".welanor-drawer__foot").innerHTML = fresh.querySelector(".welanor-drawer__foot").innerHTML;
    const count = fresh.querySelector("[data-cart-drawer-count]")?.textContent.trim();
    if (count !== undefined) setCount(Number(count) || 0);
  };
  const open = () => {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); panel.focus({ preventScroll: true }); });
    document.documentElement.classList.add("welanor-drawer-open");
  };
  const close = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("welanor-drawer-open");
    window.setTimeout(() => { drawer.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  drawer.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-drawer-close]")) close();
  });
  document.addEventListener("keydown", (event) => { if (event.key === "Escape" && drawer.classList.contains("is-open")) close(); });
  // quantity +/- inside the drawer
  drawer.addEventListener("click", async (event) => {
    const btn = event.target.closest("[data-cart-qty]");
    if (!btn) return;
    const row = btn.closest("[data-line]");
    const quantity = Math.max(0, Number(btn.dataset.cartQty) || 0);
    row.classList.add("is-busy");
    let changed = false;
    try {
      const res = await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: Number(row.dataset.line), quantity }) });
      if (!res.ok) throw new Error("cart change failed");
      changed = true;
      await refresh();
    } catch (error) {
      row.classList.remove("is-busy");
      // The quantity already changed server-side, so a stale drawer would misstate the total.
      if (changed) window.location.reload();
    }
  });
  // header cart icon opens the drawer instead of navigating (keeps the page)
  document.querySelectorAll(".mareclo-cart-link").forEach((link) => {
    link.addEventListener("click", async (event) => {
      if (window.matchMedia("(max-width: 760px)").matches) return;
      event.preventDefault();
      try { await refresh(); } catch (error) {}
      open();
    });
  });
  const flash = (button, ok) => {
    if (!button) return;
    // Own markup only (the "+ Warenkorb" spans) — restore innerHTML, not flattened text.
    const original = button.dataset.label || button.innerHTML;
    const label = button.dataset.ariaLabel || button.getAttribute("aria-label") || "";
    button.dataset.label = original;
    button.dataset.ariaLabel = label;
    button.classList.add(ok ? "is-added" : "is-error");
    button.textContent = ok ? "✓" : "!";
    button.setAttribute("aria-label", ok ? text("added") : text("error"));
    window.setTimeout(() => { button.classList.remove("is-added", "is-error"); button.innerHTML = original; if (label) button.setAttribute("aria-label", label); }, 1600);
  };
  const addVariant = async (variantId, button) => {
    if (!variantId) return;
    if (button) button.disabled = true;
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      if (!res.ok) throw new Error("add failed");
      flash(button, true);
      await refresh();
      open();
    } catch (error) {
      flash(button, false);
    } finally {
      if (button) button.disabled = false;
    }
  };
  document.addEventListener("welanor:cart:added", async () => {
    try { await refresh(); } catch (error) {}
    open();
  });
  // "+" sources: routine list (submit button name=id), look list form, product cards, focus overlay button
  document.addEventListener("click", (event) => {
    const focusAdd = event.target.closest("[data-atlas-focus-add]");
    if (focusAdd) { event.preventDefault(); addVariant(focusAdd.dataset.variantId, focusAdd); return; }
    const plus = event.target.closest(".welanor-atlas__add-one, .mareclo-card__add");
    if (!plus) return;
    const form = plus.closest("form");
    const variantId = plus.value && plus.name === "id" ? plus.value : form?.querySelector('input[name="id"]')?.value;
    if (!variantId) return;
    event.preventDefault();
    addVariant(variantId, plus);
  });
})();
